import { Container, Grid, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import bg from "./Assets/teamBg.png";
import Fade from "react-reveal/Fade";

import Tl from "./Assets/teamslower.png";
import Tu from "./Assets/teamsupper.png";

// Dataset

let Dataset = [
  {
    image: img1,
    name: "@Jellypalooza",
    designation: "Founder",
  },
  {
    image: img2,
    name: "Angel",
    designation: "Artist",
  },
  {
    image: img3,
    name: "NuttyHappy",
    designation: "Community",
  },
  {
    image: img1,
    name: "Kelvin",
    designation: "Developer",
  },
];

const Team = () => {
  const hide = useMediaQuery("(max-width:600px)");

  return (
    <div>
      <Box
        sx={
          {
            // backgroundImage: `url(${bg})`,
            // backgroundRepeat: "no-repeat",
            // backgroundPosition: "left center",
          }
        }
        mt={12}
        textAlign="center"
      >
        {hide ? (
          <></>
        ) : (
          <>
            <Box bgcolor="red" sx={{ position: "relative" }}>
              <img
                alt=""
                className="zoom-in-out-box"
                style={{
                  position: "absolute",
                  right: "-30px",
                  top: "-15px",
                  zIndex: "999",
                  width: "170px",
                }}
                src={Tu}
              />
            </Box>
          </>
        )}

        <Container maxWidth="md">
          <Grid container>
            <Grid item xs={12}>
              <Typography
                fontSize={{ xs: "26px", sm: "32px", md: "55px" }}
                sx={{
                  color: "white",
                  fontWeight: "700",
                  fontFamily: "'Baloo Bhai 2', cursive",
                  textShadow: "0px 0px 20px #FFFFFF",
                }}
              >
                THE TEAM
              </Typography>
            </Grid>
            <Grid item container justifyContent={"space-around"}>
              {Dataset.map((value, index, array) => {
                return (
                  <Grid item xs={12} md={3}>
                    <Fade left>
                      <Box mt={5}>
                        <img src={value.image} />
                        <Typography
                          mt={1}
                          sx={{
                            color: "white",
                            fontSize: "24px",
                            fontFamily: "'Baloo Bhai 2', cursive",
                          }}
                        >
                          {value.name}
                        </Typography>
                        <Typography
                          sx={{
                            color: "white",
                            fontSize: "24px",
                            fontFamily: "'Baloo Bhai 2', cursive",
                          }}
                        >
                          {value.designation}
                        </Typography>
                      </Box>
                    </Fade>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Container>

        <Box bgcolor="red" sx={{ position: "relative" }}>
          <img
            className="zoom-in-out-box"
            style={{
              position: "absolute",
              right: "80px",
              top: "-90px",
              zIndex: "9",
              width: "100px",
            }}
            src={Tu}
          />
        </Box>
      </Box>
    </div>
  );
};

export default Team;
